var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReglageIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.25C9.6736 11.25 10.625 10.2427 10.625 9.00003C10.625 7.75739 9.6736 6.75003 8.5 6.75003C7.32639 6.75003 6.375 7.75739 6.375 9.00003C6.375 10.2427 7.32639 11.25 8.5 11.25Z",
    stroke: "#EB2630",
    strokeWidth: 1.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4165 9.65998V8.33998C1.4165 7.55998 2.01859 6.91498 2.76234 6.91498C4.04442 6.91498 4.56859 5.95498 3.924 4.77748C3.55567 4.10248 3.77525 3.22498 4.41984 2.83498L5.64525 2.09248C6.20484 1.73998 6.92734 1.94998 7.26025 2.54248L7.33817 2.68498C7.97567 3.86248 9.024 3.86248 9.66859 2.68498L9.7465 2.54248C10.0794 1.94998 10.8019 1.73998 11.3615 2.09248L12.5869 2.83498C13.2315 3.22498 13.4511 4.10248 13.0828 4.77748C12.4382 5.95498 12.9623 6.91498 14.2444 6.91498C14.9811 6.91498 15.5903 7.55248 15.5903 8.33998V9.65998C15.5903 10.44 14.9882 11.085 14.2444 11.085C12.9623 11.085 12.4382 12.045 13.0828 13.2225C13.4511 13.905 13.2315 14.775 12.5869 15.165L11.3615 15.9075C10.8019 16.26 10.0794 16.05 9.7465 15.4575L9.66859 15.315C9.03109 14.1375 7.98275 14.1375 7.33817 15.315L7.26025 15.4575C6.92734 16.05 6.20484 16.26 5.64525 15.9075L4.41984 15.165C3.77525 14.775 3.55567 13.8975 3.924 13.2225C4.56859 12.045 4.04442 11.085 2.76234 11.085C2.01859 11.085 1.4165 10.44 1.4165 9.65998Z",
    stroke: "#EB2630",
    strokeWidth: 1.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReglageIconActive);
export default __webpack_public_path__ + "static/media/reglageIconActive.8bd310b012f181ffc0a51aafc3e428f0.svg";
export { ForwardRef as ReactComponent };